<div class="container term-of-services-container">
  <header class="header">
    <button class="back-button" (click)="goBack()">
      <span class="back-arrow">←</span>
    </button>
    <div class="d-flex flex-column">
      <h1 class="header-text">Terms and Conditions & End User License Agreement (EULA)</h1>
      <h5 class="header-subtitle m-0">IMPORTANT: PLEASE READ CAREFULLY</h5>
    </div>
  </header>

  <div class="content">
    <p class="last-updated">Last Updated: {{ lastUpdated }}</p>

    <section class="section">
      <p class="paragraph">
        <b>By downloading, installing, accessing, or using Insizon ("the App", "the Service"), you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions and End User License Agreement (EULA). If you do not agree to these terms, you must immediately discontinue use of the App and delete it from your device.</b>
      </p>

      <p class="paragraph">
       <b> YOU MUST EXPRESSLY AGREE TO THESE TERMS BEFORE USING THE APP. YOUR USE OF THE APP CONSTITUTES YOUR ACCEPTANCE OF THESE TERMS.</b>
      </p>
    </section>
    <section class="section">
      <h2 class="heading">1. END USER LICENSE AGREEMENT (EULA)</h2>
      <h3 class="sub-heading">1.1 License Grant</h3>
      <p class="paragraph">
        Subject to your compliance with these Terms, Insizon grants you a limited, non-exclusive, non-transferable, revocable license to access and use the App on your personal device for personal, non-commercial purposes only.
      </p>
      
      <h3 class="sub-heading">1.2 License Restrictions</h3>
      <p class="paragraph">You may NOT:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Copy, modify, distribute, sell, or lease any part of the App</li>
        <li class="bullet-point">Reverse engineer, decompile, or disassemble the App</li>
        <li class="bullet-point">Remove any proprietary notices or labels</li>
        <li class="bullet-point">Use the App for any illegal or unauthorized purpose</li>
        <li class="bullet-point">Transfer or sublicense your rights under this license</li>
      </ul>
      
      <h3 class="sub-heading">1.3 Termination of License</h3>
      <p class="paragraph">This license is effective until terminated. We may terminate your license immediately, without prior notice, if you breach these Terms. Upon termination, you must immediately cease all use of the App and delete it from your device.</p>
    
    </section>

    <section class="section">
      <h2 class="heading">2. ACCEPTANCE OF TERMS AND USER AGREEMENT</h2>
      <p class="paragraph"><b>By creating an account, accessing, or using Insizon, you represent and warrant that:</b></p>
      
      <ul class="bullet-list">
        <li class="bullet-point">You have read and understood these Terms and Conditions in their entirety</li>
        <li class="bullet-point">You agree to be legally bound by these Terms</li>
        <li class="bullet-point">You will comply with all applicable laws and regulations</li>
        <li class="bullet-point">You are at least 18 years of age and have the legal capacity to enter into this agreement</li>
        <li class="bullet-point">You understand that violation of these Terms may result in immediate account termination and legal action</li>
      </ul>
      
      <p class="paragraph"><b>If you do not agree to any part of these Terms, you must not use the App.</b></p>
    </section>
    
    <section class="section">
      <h2 class="heading">3. ZERO TOLERANCE POLICY FOR OBJECTIONABLE CONTENT AND ABUSIVE USERS</h2>
      
      <h3 class="sub-heading">3.1 Zero Tolerance Statement</h3>
      <p class="paragraph">Insizon maintains a ZERO TOLERANCE policy for objectionable content and abusive users. We are committed to providing a safe, respectful, and positive environment for all users.</p>
      
      
      <h3 class="sub-heading">3.2 Prohibited Content</h3>
      <p class="paragraph"><b>You are STRICTLY PROHIBITED from posting, sharing, transmitting, or displaying any of the following objectionable content:</b></p>
      <ul class="bullet-list">
        <li class="bullet-point"><b>Sexually Explicit Content:</b> Nudity, pornography, sexually suggestive images, or any content of a sexual nature</li>
        <li class="bullet-point"><b>Violence or Threats:</b> Content depicting violence, threats of harm, or encouraging violence against others</li>
        <li class="bullet-point"><b>Hate Speech:</b> Content that promotes hatred, discrimination, or violence based on race, ethnicity, religion, gender, sexual orientation, disability, or any other protected characteristic</li>
        <li class="bullet-point"><b>Harassment or Bullying:</b> Content intended to harass, intimidate, bully, or harm other users</li>
        <li class="bullet-point"><b>Illegal Activities:</b> Content promoting or depicting illegal activities, including but not limited to drug use, weapons, or criminal behavior</li>
        <li class="bullet-point"><b>Spam or Fraud:</b> Misleading, fraudulent, or spam content designed to deceive or defraud users</li>
        <li class="bullet-point"><b>Personal Information:</b> Sharing private information of others without consent</li>
        <li class="bullet-point"><b>Fake Profiles:</b> Creating fake accounts, impersonating others, or using false information</li>
        <li class="bullet-point"><b>Child Exploitation:</b> Any content involving minors or child exploitation (we will report such content to law enforcement immediately)</li>
      </ul>

      <h3 class="sub-heading">3.3 Prohibited User Behavior</h3>
      <p>The following abusive behaviors are STRICTLY PROHIBITED and will result in immediate account termination:</p>
      <ul class="bullet-list">
        <li class="bullet-point"><b>Harassment:</b> Repeatedly contacting, messaging, or following users who have expressed disinterest</li>
        <li class="bullet-point"><b>Threats:</b> Making threats of physical, emotional, or financial harm to other users</li>
        <li class="bullet-point"><b>Stalking:</b> Engaging in stalking behavior, including tracking users' locations or activities</li>
        <li class="bullet-point"><b>Intimidation:</b> Using intimidation tactics, coercion, or manipulation to control or harm others</li>
        <li class="bullet-point"><b>Discrimination:</b> Treating users differently or unfairly based on protected characteristics</li>
        <li class="bullet-point"><b>Abusive Language:</b> Using profanity, slurs, or offensive language directed at other users</li>
        <li class="bullet-point"><b>Unsolicited Sexual Content:</b> Sending unsolicited sexual messages, images, or content</li>
        <li class="bullet-point"><b>Scamming:</b> Attempting to defraud, scam, or financially exploit other users</li>
        <li class="bullet-point"><b>Violence:</b> Engaging in or threatening physical violence against other users</li>
        <li class="bullet-point"><b>Doxxing:</b> Sharing private or identifying information about other users without consent</li>
      </ul>

      <h3 class="sub-heading">3.4 Enforcement Actions</h3>
      <p>Violation of our Zero Tolerance Policy will result in:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Immediate account suspension or permanent termination</li>
        <li class="bullet-point">Permanent ban from the App</li>
        <li class="bullet-point">Reporting to law enforcement authorities when applicable</li>
        <li class="bullet-point">Legal action when necessary</li>
        <li class="bullet-point">No refunds for subscriptions or purchases</li>
      </ul>
      <p>We reserve the right to review, remove, or report any content or user behavior that violates these policies, even if not explicitly listed above.</p>

      <h3 class="sub-heading">3.5 Reporting Violations</h3>
      <p>If you encounter objectionable content or abusive behavior, you must:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Report it immediately using the in-app reporting feature</li>
        <li class="bullet-point">Block the user if you feel unsafe</li>
        <li class="bullet-point">Contact our support team at {{environment.SupportEmail}}</li>
        <li class="bullet-point">In cases of immediate danger, contact local law enforcement</li>
      </ul>
      <p>We take all reports seriously and will investigate promptly. Reports are confidential and anonymous to the reported user.</p>
    </section>

    <section class="section">
      <h2 class="heading">4. ELIGIBILITY REQUIREMENTS</h2>

      <h3 class="sub-heading">4.1 Age Requirement</h3>
      <p class="paragraph">You must be at least **18 years of age** to use Insizon. By creating an account, you represent and warrant that you are 18 years or older.</p>
      
      <h3 class="sub-heading">4.2 Legal Capacity</h3>
      <p class="paragraph">You must have the legal capacity to enter into binding agreements in your jurisdiction. If you are using the App on behalf of an organization, you must have authority to bind that organization to these Terms.</p>
      
      <h3 class="sub-heading">4.3 Relationship Status</h3>
      <p class="paragraph">You must be legally single and available to date. You may not use the App if you are married or in a committed relationship, unless you are in a legally recognized open relationship and have disclosed this to other users.</p>
      
      <h3 class="sub-heading">4.4 Verification Requirements</h3>
      <p>You must:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Provide accurate and truthful information during registration</li>
        <li class="bullet-point">Complete phone number verification</li>
        <li class="bullet-point">Complete email verification</li>
        <li class="bullet-point">Maintain accurate profile information</li>
        <li class="bullet-point">Use only one account per person</li>
      </ul>
      <p>Providing false information or creating multiple accounts will result in immediate account termination.</p>
    </section>
    
    <section class="section">
      <h2 class="heading">5. ACCOUNT REGISTRATION AND RESPONSIBILITIES</h2>
      
      <h3 class="sub-heading">5.1 Account Creation</h3>
      <p>To use Insizon, you must create an account by providing:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Valid email address</li>
        <li class="bullet-point">Valid phone number</li>
        <li class="bullet-point">Personal information (name, age, gender, location)</li>
        <li class="bullet-point">Profile photos (minimum required)</li>
        <li class="bullet-point">Bio and optional voice recording</li>
      </ul>
      
      <h3 class="sub-heading">5.2 Account Security</h3>
      <p>You are solely responsible for:</p>
      <ul class="bullet-list">
        <li class="bullet-point">Maintaining the confidentiality of your account credentials</li>
        <li class="bullet-point">All activities that occur under your account</li>
        <li class="bullet-point">Notifying us immediately of any unauthorized access</li>
        <li class="bullet-point">Keeping your profile information accurate and up-to-date</li>
        <li class="bullet-point">Logging out of your account on shared devices</li>
      </ul>
      <p>Your account is personal to you and may not be shared, transferred, or sold to another person. You may not create accounts for others or allow others to use your account.</p>
      
      <h3 class="sub-heading">5.3 Account Ownership</h3>
      <p>You will be held liable for any activities that occur under your account, whether authorized by you or not.</p>
    </section>

    <section class="section">
  <h2 class="heading">6. USER CONDUCT AND PROHIBITED ACTIVITIES</h2>

  <h3 class="sub-heading">6.1 General Prohibitions</h3>
  <p>In addition to the Zero Tolerance Policy outlined in Section 3, you agree NOT to:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Post false, misleading, or fraudulent information</li>
    <li class="bullet-point">Use the App for commercial purposes, advertising, or spam</li>
    <li class="bullet-point">Impersonate another person, entity, or organization</li>
    <li class="bullet-point">Share your account credentials with others</li>
    <li class="bullet-point">Attempt to reverse engineer, hack, or compromise the App's security</li>
    <li class="bullet-point">Use automated systems, bots, or scripts to access the App</li>
    <li class="bullet-point">Interfere with or disrupt the App's servers or networks</li>
    <li class="bullet-point">Violate any applicable local, state, national, or international laws or regulations</li>
    <li class="bullet-point">Collect or harvest information about other users without consent</li>
    <li class="bullet-point">Use the App to promote other services, products, or websites</li>
  </ul>

  <h3 class="sub-heading">6.2 Content Standards</h3>
  <p>All content you post, including photos, bios, messages, and voice recordings, must:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Be accurate and truthful</li>
    <li class="bullet-point">Be your own original content (or you must have permission to use it)</li>
    <li class="bullet-point">Comply with all applicable laws</li>
    <li class="bullet-point">Respect the rights and dignity of others</li>
    <li class="bullet-point">Not infringe on intellectual property rights</li>
  </ul>

  <h3 class="sub-heading">6.3 Consequences of Violations</h3>
  <p>Violation of these conduct rules may result in:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Warning or temporary suspension</li>
    <li class="bullet-point">Permanent account termination</li>
    <li class="bullet-point">Legal action</li>
    <li class="bullet-point">Reporting to law enforcement</li>
    <li class="bullet-point">No refunds for subscriptions or purchases</li>
  </ul>
</section>

   <section class="section">
  <h2 class="heading">7. SUBSCRIPTION PLANS AND PAYMENTS</h2>

  <h3 class="sub-heading">7.1 Subscription Tiers</h3>
  <p>Insizon offers the following subscription plans:</p>
  <ul class="bullet-list">
    <li class="bullet-point">No subscriptions currently</li>
  </ul>

  <h3 class="sub-heading">7.2 Payment Terms</h3>
  <p>By purchasing a subscription:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Payments are processed through Apple App Store or Google Play Store</li>
    <li class="bullet-point">Subscriptions automatically renew unless cancelled at least 24 hours before the renewal date</li>
    <li class="bullet-point">You are responsible for all charges until you cancel your subscription</li>
    <li class="bullet-point">Refunds are subject to Apple App Store and Google Play Store policies</li>
    <li class="bullet-point">We reserve the right to change subscription prices with 30 days' notice</li>
    <li class="bullet-point">All prices are displayed in your local currency</li>
  </ul>

  <h3 class="sub-heading">7.3 Cancellation</h3>
  <p>You may cancel your subscription at any time through your device's app store settings:</p>
  <ul class="bullet-list">
    <li class="bullet-point"><strong>iOS:</strong> Settings &gt; [Your Name] &gt; Subscriptions &gt; Insizon &gt; Cancel Subscription</li>
    <li class="bullet-point"><strong>Android:</strong> Google Play Store &gt; Subscriptions &gt; Insizon &gt; Cancel</li>
  </ul>
  <p>Cancellation will take effect at the end of the current billing period. You will continue to have access to premium features until the subscription period ends.</p>

  <h3 class="sub-heading">7.4 Refunds</h3>
  <p>Refund requests must be submitted through Apple App Store or Google Play Store in accordance with their refund policies. We do not provide direct refunds. Refunds are not available for:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Partial subscription periods</li>
    <li class="bullet-point">Unused features or benefits</li>
    <li class="bullet-point">Account termination due to Terms violations</li>
  </ul>
</section>

   <section class="section">
  <h2 class="heading">8. FEATURES AND SERVICES</h2>
  <h3 class="sub-heading">8.4 Service Availability</h3>
  <p>We do not guarantee:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Continuous, uninterrupted, or error-free service</li>
    <li class="bullet-point">Specific number of matches or connections</li>
    <li class="bullet-point">Successful relationships or dates</li>
    <li class="bullet-point">Availability of specific features at all times</li>
  </ul>
</section>

<section class="section">
  <h2 class="heading">9. INTELLECTUAL PROPERTY RIGHTS</h2>

  <h3 class="sub-heading">9.1 Our Intellectual Property</h3>
  <p>All content, features, and functionality of Insizon, including but not limited to:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Text, graphics, logos, images, and software</li>
    <li class="bullet-point">App design, layout, and user interface</li>
    <li class="bullet-point">Algorithms, code, and technical processes</li>
    <li class="bullet-point">Trademarks, service marks, and brand names</li>
  </ul>
  <p>Are the exclusive property of Insizon and its licensors and are protected by copyright, trademark, patent, and other intellectual property laws.</p>

  <h3 class="sub-heading">9.2 Your Content License</h3>
  <p>You retain ownership of content you post on the App. However, by posting content, you grant us a worldwide, royalty-free, perpetual, irrevocable, non-exclusive license to:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Use, display, reproduce, and distribute your content within the App</li>
    <li class="bullet-point">Modify your content as necessary to provide services</li>
    <li class="bullet-point">Use your content for promotional purposes (with your consent)</li>
    <li class="bullet-point">Store and backup your content on our servers</li>
  </ul>

  <h3 class="sub-heading">9.3 User Content Responsibilities</h3>
  <p>You are solely responsible for:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Ensuring you have the right to post your content</li>
    <li class="bullet-point">Obtaining necessary permissions for content featuring others</li>
    <li class="bullet-point">Respecting intellectual property rights of others</li>
    <li class="bullet-point">Not posting copyrighted material without authorization</li>
  </ul>
</section>


    <section class="section">
  <h2 class="heading">10. PRIVACY AND DATA PROTECTION</h2>

  <h3 class="sub-heading">10.1 Privacy Policy</h3>
  <p>Your use of the App is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal information. By using the App, you consent to our Privacy Policy.</p>

  <h3 class="sub-heading">10.2 Data Security</h3>
  <p>We implement industry-standard security measures to protect your data. However, no method of transmission or storage is 100% secure. You use the App at your own risk.</p>

  <h3 class="sub-heading">10.3 Location Data</h3>
  <p>The App uses your location to provide matching services. You can control location sharing through your device settings, but some features may not work without location access.</p>
</section>

<section class="section">
  <h2 class="heading">11. LIMITATION OF LIABILITY</h2>

  <h3 class="sub-heading">11.1 Disclaimer of Warranties</h3>
  <p><strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW:</strong></p>
  <ul class="bullet-list">
    <li class="bullet-point">Insizon is provided "AS IS" and "AS AVAILABLE" without warranties of any kind, either express or implied</li>
    <li class="bullet-point">We do not guarantee that the App will meet your requirements or expectations</li>
    <li class="bullet-point">We do not guarantee matches, successful relationships, or any specific outcomes</li>
    <li class="bullet-point">We do not warrant that the App will be uninterrupted, secure, or error-free</li>
    <li class="bullet-point">We are not responsible for user interactions, conduct, or content posted by other users</li>
  </ul>

  <h3 class="sub-heading">11.2 Limitation of Liability</h3>
  <p><strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW:</strong></p>
  <ul class="bullet-list">
    <li class="bullet-point">We are not liable for any indirect, incidental, special, consequential, or punitive damages</li>
    <li class="bullet-point">We are not liable for loss of profits, data, goodwill, or other intangible losses</li>
    <li class="bullet-point">We are not responsible for any harm resulting from your use of the App</li>
    <li class="bullet-point">We are not responsible for interactions between users, including dates, relationships, or disputes</li>
    <li class="bullet-point">Our total liability to you for any claims shall not exceed the amount you paid for subscriptions in the past 12 months</li>
  </ul>

  <h3 class="sub-heading">11.3 User Interactions</h3>
  <p><strong>You acknowledge and agree that:</strong></p>
  <ul class="bullet-list">
    <li class="bullet-point">We are not responsible for the conduct of other users</li>
    <li class="bullet-point">We do not screen or verify user information</li>
    <li class="bullet-point">You are solely responsible for your interactions with other users</li>
    <li class="bullet-point">You should exercise caution and good judgment when meeting people in person</li>
    <li class="bullet-point">We are not liable for any harm that occurs during or after in-person meetings</li>
  </ul>
</section>

<section class="section">
  <h2 class="heading">12. DISPUTE RESOLUTION</h2>

  <h3 class="sub-heading">12.1 Informal Resolution</h3>
  <p>If you have a dispute with us, you agree to first contact us at {{environment.SupportEmail}} to attempt to resolve the dispute informally.</p>

  <h3 class="sub-heading">12.2 Binding Arbitration</h3>
  <p>If informal resolution fails, any disputes arising from these Terms or your use of the App shall be resolved through binding arbitration in accordance with the rules of [Arbitration Organization], except where prohibited by law.</p>

  <h3 class="sub-heading">12.3 Class Action Waiver</h3>
  <p>You agree that disputes will be resolved individually and not as part of a class action, consolidated action, or representative proceeding.</p>

  <h3 class="sub-heading">12.4 Governing Law</h3>
  <p>These Terms shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions.</p>
</section>

<section class="section">
  <h2 class="heading">13. ACCOUNT TERMINATION</h2>

  <h3 class="sub-heading">13.1 Termination by You</h3>
  <p>You may delete your account at any time through the Help & Account Settings section in the App. Account deletion will:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Deactivate your account (soft delete)</li>
    <li class="bullet-point">Remove your profile from discovery</li>
    <li class="bullet-point">Cancel active subscriptions</li>
    <li class="bullet-point">Delete your messages and matches (subject to data retention policies)</li>
    <li class="bullet-point">Some data may be retained for legal or business purposes as required by law</li>
  </ul>

  <h3 class="sub-heading">13.2 Termination by Us</h3>
  <p>We reserve the right to suspend or terminate your account immediately, without prior notice, if you:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Violate these Terms and Conditions or our Zero Tolerance Policy</li>
    <li class="bullet-point">Engage in fraudulent, illegal, or harmful activity</li>
    <li class="bullet-point">Harass, abuse, or harm other users</li>
    <li class="bullet-point">Post objectionable content</li>
    <li class="bullet-point">Fail to pay subscription fees</li>
    <li class="bullet-point">Provide false or misleading information</li>
    <li class="bullet-point">Create multiple accounts</li>
    <li class="bullet-point">Use the App in any way that violates applicable laws</li>
  </ul>

  <h3 class="sub-heading">13.3 Effect of Termination</h3>
  <p>Upon termination:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Your right to use the App immediately ceases</li>
    <li class="bullet-point">You must immediately delete the App from your device</li>
    <li class="bullet-point">We may delete your account, profile, and content</li>
    <li class="bullet-point">You will not receive refunds for unused subscription time</li>
    <li class="bullet-point">Provisions that by their nature should survive termination will remain in effect</li>
  </ul>
</section>
<section class="section">
  <h2 class="heading">14. REPORTING AND MODERATION</h2>

  <h3 class="sub-heading">14.1 Reporting System</h3>
  <p>We provide multiple ways to report violations:</p>
  <ul class="bullet-list">
    <li class="bullet-point">In-app reporting feature for objectionable content or abusive behavior</li>
    <li class="bullet-point">Block feature to prevent further contact from specific users</li>
    <li class="bullet-point">Email support at {{environment.SupportEmail}}</li>
    <li class="bullet-point">Emergency contact: {{environment.SupportEmail}}</li>
  </ul>

  <h3 class="sub-heading">14.2 Our Response</h3>
  <p>We will:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Review all reports promptly and thoroughly</li>
    <li class="bullet-point">Take appropriate action, including warnings, suspensions, or permanent bans</li>
    <li class="bullet-point">Report serious violations to law enforcement when necessary</li>
    <li class="bullet-point">Maintain confidentiality of reports (reported users will not see reporter information)</li>
    <li class="bullet-point">Notify you of actions taken when appropriate</li>
  </ul>

  <h3 class="sub-heading">14.3 False Reports</h3>
  <p>Filing false or malicious reports may result in your account being terminated.</p>
</section>

<section class="section">
  <h2 class="heading">15. CHANGES TO TERMS</h2>

  <h3 class="sub-heading">15.1 Right to Modify</h3>
  <p>We reserve the right to modify these Terms at any time. We will notify you of significant changes through:</p>
  <ul class="bullet-list">
    <li class="bullet-point">In-app notifications</li>
    <li class="bullet-point">Email to your registered email address</li>
    <li class="bullet-point">Updates to the "Last Updated" date at the top of this document</li>
  </ul>

  <h3 class="sub-heading">15.2 Acceptance of Changes</h3>
  <p>Continued use of the App after changes to these Terms constitutes your acceptance of the modified Terms. If you do not agree to the modified Terms, you must stop using the App and delete your account.</p>

  <h3 class="sub-heading">15.3 Material Changes</h3>
  <p>For material changes that significantly affect your rights or obligations, we will provide at least 30 days' notice before the changes take effect.</p>
</section>

<section class="section">
  <h2 class="heading">16. THIRD-PARTY SERVICES</h2>

  <h3 class="sub-heading">16.1 Third-Party Integrations</h3>
  <p>The App may integrate with third-party services, including:</p>
  <ul class="bullet-list">
    <li class="bullet-point">Payment processors (Apple App Store, Google Play Store)</li>
    <li class="bullet-point">Cloud storage providers</li>
    <li class="bullet-point">Analytics services</li>
    <li class="bullet-point">Social media platforms (optional)</li>
  </ul>

  <h3 class="sub-heading">16.2 Third-Party Terms</h3>
  <p>Your use of third-party services is subject to their respective terms and conditions and privacy policies. We are not responsible for third-party services or their terms.</p>
</section>

<!-- Start of Twilio Compliant SMS Terms Section -->
<section id="sms-terms-conditions" style="margin-top: 20px; margin-bottom: 20px;">
    <h2>17. SMS Terms of Service</h2>
    <p>By opting into the Insizon, LLC text messaging service, you expressly agree to the following terms and conditions:</p>
    <ul>
        <li><strong>Program Description:</strong> Insizon, LLC sends account-related notifications, including password resets, security alerts, billing notices, and system status updates, directly to registered users who have explicitly opted in.</li>
        <li><strong>Message Frequency:</strong> Message frequency varies based on user interaction, account activity, and your personal account settings.</li>
        <li><strong>Pricing and Fees:</strong> Message and data rates may apply for any messages sent to you from us and to us from you. Insizon, LLC does not charge a separate fee for this service, but standard carrier charges apply.</li>
        <li><strong>Supported Carriers:</strong> Mobile carriers are not liable for delayed or undelivered messages. The service is available on all major US wireless providers.</li>
        <li><strong>Cancellation & Opt-Out:</strong> You can cancel the SMS service at any time. Just text "<strong>STOP</strong>" to our number. After you send the message "STOP", we will send you a confirmation text. Once confirmed, you will no longer receive SMS messages from us unless you re-register.</li>
        <li><strong>Customer Support:</strong> If you experience any issues with our text messaging program, you can text "<strong>HELP</strong>" for immediate assistance or contact us directly at <a href="mailto:support@insizon.com">support@insizon.com</a>.</li>
    </ul>
</section>
<!-- End of Twilio Compliant SMS Terms Section -->

<section class="section">
  <h2 class="heading">18. CONTACT INFORMATION</h2>

  <h3 class="sub-heading">18.1 Support</h3>
  <p>If you have questions, concerns, or need assistance regarding these Terms and Conditions, please contact us:</p>
  <ul class="bullet-list">
    <li class="bullet-point"><strong>Email:</strong> {{environment.SupportEmail}}</li>
    <li class="bullet-point"><strong>In-App:</strong> Help & Account Settings section</li>
    <li class="bullet-point"><strong>Response Time:</strong> We aim to respond within 48 hours</li>
  </ul>

  <h3 class="sub-heading">18.2 Legal Notices</h3>
  <p>For legal notices or formal complaints, please send written correspondence to:</p>
  <p>
    {{environment.BusinessName}}<br>
    {{environment.BusinessAddress.Street}}<br>
    {{getBusinessAddressLine2}}<br>
    {{environment.BusinessAddress.Country}}
  </p>
</section>

<section class="section">
  <h2 class="heading">19. MISCELLANEOUS PROVISIONS</h2>

  <h3 class="sub-heading">19.1 Entire Agreement</h3>
  <p>These Terms, together with our Privacy Policy, constitute the entire agreement between you and Insizon regarding your use of the App.</p>

  <h3 class="sub-heading">19.2 Severability</h3>
  <p>If any provision of these Terms is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.</p>

  <h3 class="sub-heading">19.3 Waiver</h3>
  <p>Our failure to enforce any right or provision of these Terms shall not constitute a waiver of such right or provision.</p>

  <h3 class="sub-heading">19.4 Assignment</h3>
  <p>You may not assign or transfer these Terms or your account without our prior written consent. We may assign these Terms without restriction.</p>

  <h3 class="sub-heading">19.5 Force Majeure</h3>
  <p>We are not liable for any failure to perform our obligations due to circumstances beyond our reasonable control, including natural disasters, war, terrorism, labor disputes, or technical failures.</p>
</section>

<section class="section">
  <h2 class="heading">ACKNOWLEDGMENT</h2>

  <p><strong>BY USING Insizon, YOU ACKNOWLEDGE THAT:</strong></p>

  <ul class="bullet-list">
    <li class="bullet-point"><strong>You have read and understood these Terms and Conditions and End User License Agreement in their entirety</strong></li>
    <li class="bullet-point"><strong>You agree to be legally bound by these Terms</strong></li>
    <li class="bullet-point"><strong>You understand and accept our Zero Tolerance Policy for objectionable content and abusive users</strong></li>
    <li class="bullet-point"><strong>You will comply with all applicable laws and regulations</strong></li>
    <li class="bullet-point"><strong>You are at least 18 years of age and have the legal capacity to enter into this agreement</strong></li>
    <li class="bullet-point"><strong>You understand that violation of these Terms may result in immediate account termination, legal action, and reporting to law enforcement</strong></li>
    <li class="bullet-point"><strong>You accept that we are not responsible for user interactions, conduct, or outcomes</strong></li>
    <li class="bullet-point"><strong>You use the App at your own risk</strong></li>
  </ul>

  <p><strong>If you do not agree to any of the above, you must immediately stop using the App and delete it from your device.</strong></p>
</section>

  </div>
</div>
